module.exports = __webpack_public_path__ + "static/media/achievement-gratitude-list.a7854691.svg";